import React from 'react';

import { ScrollView } from '@rbilabs/universal-components';

import { CardModalHeader } from 'components/card-modal-header';
import Modal, { ModalContent } from 'components/modal';
import { useUIContext } from 'state/ui';

import { DiagnosticModalContents } from './diagnostic-modal-contents';

export const StoreDiagnosticsModal = () => {
  const { storeDiagnostics } = useUIContext();
  if (!storeDiagnostics.store) {
    return null;
  }
  return (
    <Modal
      header={
        <CardModalHeader headerText="Store Diagnostics" onDismiss={storeDiagnostics.closeModal} />
      }
      allowsDismiss={false}
      onDismiss={storeDiagnostics.closeModal}
      amplitudeEventData={{
        modalAppearanceEventMessage: 'Store Diagnostics',
      }}
    >
      <ModalContent flex={1}>
        <ScrollView>
          <DiagnosticModalContents store={storeDiagnostics.store} />
        </ScrollView>
      </ModalContent>
    </Modal>
  );
};
